import template from "./bAnnualSetOffs.html";
import moment from "moment";

export function bAnnualSetOffsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bAnnualSetOffsController,
    controllerAs: 'bAnnualSetOffs',
    bindToController: true,
    scope: {
      employeeData: "=",
      showModal: "=",
      employeeId: "=",
      employeeView: "=",
      overtimeApplicationsFlag: "=?",
      isManagementView: "=?"
    },
  };

  return directive;
}

class bAnnualSetOffsController {
  constructor(API, Stats, Notes, bModal, $translate, $scope, $interval, $filter, $rootScope, $q, OvertimeApplications) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.API = API;
    this.Stats = Stats;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$q = $q;
    this.expiresAt = "";
    this.annualObjects = [];
    this.employeeView = false;
    this.$rootScope = $rootScope;
    this.OvertimeApplications = OvertimeApplications;

    this.data = "";
    this.employee = "";

    this.shareHeaders = [
      {name: this.$translate.instant("OVERTIME.MODAL.DATE"), class: "table-short", sort: "year"},
      {
        name: this.$translate.instant("OVERTIME.MODAL.OVER_TIME_BALANCE"),
        class: "table-short",
        sort: "cumulatedOvertime"
      },
      {name: this.$translate.instant("OVERTIME.MODAL.ACCEPTED_TIME_BALANCE"), class: "table-short", sort: "validFrom"},
      {name: this.$translate.instant("OVERTIME.MODAL.WORKLOGS_ACCEPTED"), class: "table-short", sort: "validUntil"},
      {name: this.$translate.instant("OVERTIME.MODAL.USED_OVERTIMES"), class: "table-short"},
      {name: this.$translate.instant("OVERTIME.MODAL.COMMENT"), class: "table-short", sort: "comment"},
      {id: "actions", name: null, class: "table-actions"},
    ];
    this.state = "loading";
  }

  init() {
    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {
      this.$interval.cancel(timeout);
    });

    this.state = "loading";

    let requests = [];

    if (this.employeeView === true) {
      requests = [this.Stats.getAnnualSetOffsDataEmployee(this.employee.id)];

      if (this.overtimeApplicationsFlag)
        requests.push(this.OvertimeApplications.getEmployeeAnnuals());

      this.$q.all(requests).then(res => {
        const overtimeRequestInfo = res[1] ? res[1].data : [];
        const userAnnualSetOffs = res[0].data.userAnnualSetOffs.annualSetOffs.map((x) => {
          const overtimeRequestPerYear = overtimeRequestInfo.find(info => info.year === x.year) || {};

          return {
            ...x,
            acceptedBalance: x.acceptedBalance,
            isEdited: false,
            acceptedWorklogPercentage: x.acceptedWorklogPercentage,
            comment: x.comment,
            cumulatedOvertime: this.getCumulatedRounded(x),
            usedOvertime: x.usedOvertime,
            secondEntry: x.acceptedBalance,
            year: x.year,
            oldComment: x.comment,
            oldAcceptedBalance: x.acceptedBalance,
            acceptedBalanceEdit: x.acceptedBalance !== undefined ? this.$filter("hmsa")(x.acceptedBalance) : this.$filter("hmsa")(moment.duration().toJSON()),
            sortCumulatedOvertime: moment.duration(x.cumulatedOvertime)._milliseconds,
            sortAcceptedBalance: moment.duration(x.acceptedBalance)._milliseconds,
            sortCumulatedApplicationOvertime: moment.duration(overtimeRequestPerYear.cumulatedApplicationOvertime)._milliseconds,
            overtimeRequestAcceptedBalance: overtimeRequestPerYear.acceptedBalance,
            cumulatedApplicationOvertimeRequest: overtimeRequestPerYear.cumulatedApplicationOvertime || "PT0S",
          };
        }).sort((a, b) => new Date(b.year) - new Date(a.year));
        this.annualObjects = userAnnualSetOffs;
        this.state = "loaded";
      }, () => {
        this.state = "error";
      });
    } else {
      requests = [this.Stats.getAnnualSetOffsData(this.employee.id, this.isManagementView)];

      if (this.overtimeApplicationsFlag)
        if (this.isManagementView)
          requests.push(this.OvertimeApplications.getMVAnnuals(this.employee.id));
        else
          requests.push(this.OvertimeApplications.getTLVAnnulas(this.employee.id));

      this.$q.all(requests).then(res => {
        const overtimeRequestInfo = res[1] ? res[1].data : [];
        const userAnnualSetOffs = res[0].data.userAnnualSetOffs.annualSetOffs.map((x) => {
          const overtimeRequestPerYear = overtimeRequestInfo.find(info => info.year === x.year) || {};
          
          return {
            ...x,
            acceptedBalance: x.acceptedBalance,
            isEdited: x.acceptedBalance === undefined,
            acceptedWorklogPercentage: x.acceptedWorklogPercentage,
            comment: x.comment,
            cumulatedOvertime: this.getCumulatedRounded(x),
            usedOvertime: x.usedOvertime,
            secondEntry: x.acceptedBalance,
            year: x.year,
            oldComment: x.comment,
            oldAcceptedBalance: x.acceptedBalance,
            acceptedBalanceEdit: x.acceptedBalance !== undefined ? this.$filter("hmsa")(x.acceptedBalance) : this.$filter("hmsa")(moment.duration(x.cumulatedOvertime).toJSON()),
            sortCumulatedOvertime: moment.duration(x.cumulatedOvertime)._milliseconds,
            sortAcceptedBalance: moment.duration(x.acceptedBalance)._milliseconds,
            sortCumulatedApplicationOvertime: moment.duration(overtimeRequestPerYear.cumulatedApplicationOvertime)._milliseconds,
            overtimeRequestAcceptedBalance: overtimeRequestPerYear.acceptedBalance,
            cumulatedApplicationOvertimeRequest: overtimeRequestPerYear.cumulatedApplicationOvertime || "PT0S",
          };
        }).sort((a, b) => new Date(b.year) - new Date(a.year));
        this.annualObjects = userAnnualSetOffs;
        this.state = "loaded";
      }, () => {
        this.state = "error";
      });
    }

  }

  getCumulatedRounded(x) {
    return this.$filter("hmsa")(moment.duration(x.cumulatedOvertime).toJSON());
  }


  setupData(data) {
    this.employee = data.employeeData;
    this.employeeView = data.employeeView;
    this.init();
  }

  closeShareModal() {
    this.$rootScope.reloadOvertime = true;
    this.showModal = false;
  }

  editShare(annualObject) {
    annualObject.isEdited = true;
  }

  inputBlur(o) {
    if (o.acceptedBalanceEdit === '0') {
      o.acceptedBalanceEdit = "00:00:00";
      o.durationInvalid = false;
    }
  }

  saveAnnual(annual) {
    const data = {
      userId: this.employee.id,
      year: annual.year,
      cumulatedOvertime: moment.duration(annual.cumulatedOvertime).toJSON(),
      acceptedBalance: moment.duration(annual.acceptedBalanceEdit).toJSON(),
      comment: annual.comment
    };

    let requests = [this.Stats.saveAnnualSetOff(data, this.isManagementView)];

    if (annual.sortCumulatedApplicationOvertime > 0 && annual.overtimeRequestAcceptedBalance !== annual.cumulatedApplicationOvertimeRequest) {
      const overtimeApplicationData = {
        userId: this.employee.id,
        year: annual.year,
        acceptedBalance: annual.cumulatedApplicationOvertimeRequest
      };
      
      delete overtimeApplicationData.cumulatedOvertime;
      requests.push(this.OvertimeApplications.saveAnnual(overtimeApplicationData, this.isManagementView));
    }

    this.$q.all(requests).then(() => {
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
      annual.isEdited = false;
      this.annualObjects.map(annualObject => {
        if (annualObject.year === data.year) {
          annualObject.oldComment = data.comment;
          annualObject.secondEntry = data.acceptedBalance;

          if (requests[1])
            annualObject.overtimeRequestAcceptedBalance = annualObject.cumulatedApplicationOvertimeRequest;
        }
      });
    }, (res) => {

      this.modalConfig = {
        text: res.data && res.data.message,
        acceptText: this.$translate.instant("OK"),
        cancelText: "",
        hideLeftButton: "hide"
      };

      this.bModal.show(this.modalConfig).then(() => {
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);
  }

  editCancel(annualObject) {
    annualObject.comment = annualObject.oldComment;
    annualObject.acceptedBalance = annualObject.oldAcceptedBalance;
    annualObject.isEdited = false;
  }

  inputChange(annualObject) {
    if (annualObject.acceptedBalanceEdit === '0') {
      annualObject.acceptedBalanceEdit = "00:00:00";
      annualObject.durationInvalid = false;
    }
    else {
      let format = /^-?(\d+):(?:[012345]\d):(?:[012345]\d)/;
      let match = annualObject.acceptedBalanceEdit.match(format);

      if (match) { annualObject.durationInvalid = false; }
      else { annualObject.durationInvalid = true; }
    }
  }
}
